export const unitSystems = {
    english: 'english',
    metric: 'metric'
};

export const unitSystemsEnum = {
    1: 'english',
    2: 'metric'
};

export const unitSystemType = {
    english: 1,
    metric: 2
};

export const temperatureUnitsEnum = {
    1: 'fahrenheit',
    2: 'celsius'
};

export const temperatureUnits = {
    fahrenheit: 1,
    celsius: 2
};

export const temperatureUnitAbbreviations = {
    1: '°F',
    2: '°C'
};

export function getTemperatureUnit(temperatureUnit = temperatureUnits.fahrenheit) {
    return temperatureUnit === temperatureUnits.fahrenheit ? unitSystems.english : unitSystems.metric;
}

export const lengthUnitsLongAbbreviations = {
    1: 'in',
    2: 'mm',
    3: 'cm'
};

export const lengthUnitsEnum = {
    1: 'inches',
    2: 'millimeters',
    3: 'centimeters'
};

export const lengthUnits = {
    inches: 1,
    millimeters: 2,
    centimeters: 3
};

export const lengthUnitsRates = {
    inches: 'InchesPerHour',
    millimeters: 'MillimetersPerHour',
    centimeters: 'CentimetersPerHour'
};

export const lengthUnitAbbreviations = {
    1: '"',
    2: 'mm',
    3: 'cm'
};

export const depthUnits = {
    inches: 1,
    centimeters: 2
};

export const depthUnitAbbreviations = {
    1: '"',
    2: 'cm'
};

export const heightUnits = {
    feet: 1,
    meters: 2
};

export const heightUnitAbbreviations = {
    1: 'ft',
    2: 'm'
};

export function getLengthUnitType(lengthUnit = lengthUnits.inches) {
    return lengthUnit === lengthUnits.inches ? unitSystems.english : unitSystems.metric;
}

export const speedUnitsEnum = {
    1: 'mph',
    2: 'kph',
    3: 'knots',
    4: 'mps'
};

export const speedUnits = {
    mph: 1,
    kph: 2,
    knots: 3,
    mps: 4
};

export const pressureUnitsEnum = {
    1: 'inches',
    2: 'millibars'
};

export const pressureUnits = {
    inches: 1,
    millibars: 2
};

export const pressureUnitAbbreviations = {
    1: '"',
    2: 'mb'
};

export const pressureUnitLongAbbreviations = {
    1: 'inHg',
    2: 'mbar'
};

export const distanceUnitsEnum = {
    1: 'miles',
    2: 'kilometers'
};

export const distanceUnits = {
    miles: 1,
    kilometers: 2
};

export const distanceUnitAbbreviations = {
    1: 'mi',
    2: 'km'
};

export const earthConstants = {
    equatorialRadiusInKilometers: 6378.1370,
    equatorialRadiusInStatuteMiles: 3963.1906
};

export interface SpecificUnits {
    temperatureUnit?: string;
    pressureUnit?: string;
    directionUnit?: string;
    distanceUnit?: string;
    speedUnit?: string;
    precipitationUnit?: string;
    precipitationRateUnit?:string;   
}

export interface GetDailyForecastByLatLonV5Params {
    location: string;
    locationType: string;
    offset: number;
    baseUrl: string;
    authId: string;
    secret: string;
    stdParameters: Record<string, unknown>;
    verbose?: boolean;
    refresh?: boolean;
    /**
     * 1: 'none': values returned as is without any rounding.
     * 2: 'precise': all values are rounded to 4 decimal places.
     * 3: 'displayLegacyV1': implements rounding approach used by the API before adding 'rounding' parameter.
     * 4: 'displayV1': implements rounding approach to produce values with precision required to display values on UI in client applications.
     */
    roundingProfile?: 'none' | 'precise' | 'displayLegacyV1' | 'displayV1';
    specificUnits: SpecificUnits;
}